module.exports = __webpack_public_path__ + "img/Bloque_QR.64fc991.svg";